import { render } from "./VehicleContainer.vue?vue&type=template&id=863e0844"
import script from "./VehicleContainer.vue?vue&type=script&lang=js"
export * from "./VehicleContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__